import { render, staticRenderFns } from "./dormitoryStaff.vue?vue&type=template&id=3d20f77f&scoped=true&"
import script from "./dormitoryStaff.vue?vue&type=script&lang=js&"
export * from "./dormitoryStaff.vue?vue&type=script&lang=js&"
import style0 from "./dormitoryStaff.vue?vue&type=style&index=0&id=3d20f77f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20f77f",
  null
  
)

export default component.exports